import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import { $ } from '@utils/dom';

const SWIPER_OPTIONS = {
  modules: [Navigation],
  centeredSlides: false,
  freeMode: false,
  slidesPerView: 1,
  spaceBetween: 12,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  watchSlidesProgress: true,
  navigation: {
    prevEl: '.pb-row-featured-posts__prev',
    nextEl: '.pb-row-featured-posts__next',
  },
  breakpoints : {
    768: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 30
    }
  }
};

class PbRowFeaturedPosts {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.slider = $('.pb-row-featured-posts__postsSlider', this.el);
    this.nav = $('.pb-row-featured-posts__postsNav', this.el);

    this.swiper = null;

    this._onSwiperChange = this._onSwiperChange.bind(this);
  }

  init() {
    if( this.slider ) this.swiper = new Swiper(this.slider, { ...SWIPER_OPTIONS, ...{on: {init: this._onSwiperChange, slidesUpdated: this._onSwiperChange}}});

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    if (this.swiper) this.swiper.destroy(true, false);

    this.el = null;
    this.emitter = null;
    this.slider = null;
    this.swiper = null;

    this._onSwiperChange = null;
  }

  _bindEvents() {}
  _unbindEvents() {}

  _onSwiperChange(swiper) {
    const { isBeginning, isEnd } = swiper;

    if( this.nav ) this.nav.setAttribute('aria-hidden', isBeginning && isEnd ? true : false);
  }
}


export default PbRowFeaturedPosts;
